import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '0px 24px',
    height: 80,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    borderBottom: 'solid 1px lightgrey'
  },
  header: {
    fontSize: theme.size.lg
  },
  action: {
    marginRight: 8
  }
}))

export default useStyles
